"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Segment", {
    enumerable: true,
    get: function() {
        return Segment;
    }
});
var _loadSnippet = require("./loadSnippet");
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Segment = function Segment(config) {
    "use strict";
    _class_call_check(this, Segment);
    _define_property(this, "identify", function(userId, traits) {
        window.analytics.identify(userId, traits);
    });
    _define_property(this, "group", function(groupId, traits) {
        window.analytics.group(groupId, traits);
    });
    _define_property(this, "page", function(pageName) {
        var traits = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var category = traits.category, rest = _object_without_properties(traits, [
            "category"
        ]);
        if (category) {
            window.analytics.page(category, pageName, rest);
        } else {
            window.analytics.page(pageName, rest);
        }
    });
    _define_property(this, "track", function(eventName, traits) {
        window.analytics.track(eventName, traits);
    });
    _define_property(this, "reset", function() {
        window.analytics.reset();
    });
    // Not supported
    _define_property(this, "revenue", function() {});
    if (!config.writeKey) {
        throw new Error('Segment writeKey is required for analytics');
    }
    var analytics = (0, _loadSnippet.loadSnippet)();
    analytics.load(config.writeKey);
};
